import { Block } from "@block";
import { useMobileMediaQuery } from "@media-query";
import ScreenNameType from "@navigation/nav-screens";
import { StackActions, useNavigation } from "@react-navigation/core";
import { spacing } from "@styles/spacing";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import { QueueSpacing } from "app/shared/components/spacing";
import { Constant } from "app/shared/constant/constant";
import { ACCOUNT } from "app/shared/services/services-model.type";
import { mapAccountPayments } from "app/shared/util/common";
import React from "react";
import { useTranslation } from "react-i18next";
import { ScrollView, StyleSheet } from "react-native";
import { Button, useTheme } from "react-native-paper";
import { useDispatch, useSelector } from "react-redux";
import { fetchListAccountRequest } from "../reducer/actions";
import { getListAccountSelector } from "../reducer/selectors";
import AccountRollItem from "./account-roll-item/account-roll-item";
import AccountRollTable from "./account-roll-item/account-roll-table";

const AccountRoll = () => {
  const { colors } = useTheme();
  const { t } = useTranslation();
  const isMobile = useMobileMediaQuery();

  const { dispatch, navigate } = useNavigation();
  const dispatchStore = useDispatch();

  const goHome = () => {
    dispatch(StackActions.replace(ScreenNameType.HOME));
  };

  const goManager = () => {
    dispatch(StackActions.replace(ScreenNameType.LIST_ACCOUNT_MANAGEMENT));
  };

  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => goHome(),
    },
    {
      name: t("ACC_QUAN_LY_TAI_KHOAN"),
      onPressSubtitle: () => goManager(),
    },
    {
      name: t("ACC_DANH_SACH_TAI_KHOAN"),
      onPressSubtitle: () => {},
    },
  ];

  const styles = React.useMemo(
    () =>
      StyleSheet.create({
        buttonForm: { width: 128, alignSelf: "center", backgroundColor: colors.backgroundForm },
      }),
    [colors],
  );

  const listAccountStore = useSelector(getListAccountSelector);

  const [data, setData] = React.useState<{ Payments: ACCOUNT[]; Terms: ACCOUNT[]; Loans: ACCOUNT[] }>({
    Payments: [],
    Terms: [],
    Loans: [],
  });

  const accountPayment = (e: ACCOUNT) => e.ACCOUNTTYPE === Constant.ACCOUNTTYPE.ACCOUNT_PAYMENT;
  const accountSaving = (e: ACCOUNT) => Constant.ACCOUNTTYPE.ACCOUNT_TERM_DEPOSIT.includes(e.ACCOUNTTYPE || "");
  const accountLoan = (e: ACCOUNT) => e.ACCOUNTTYPE === Constant.ACCOUNTTYPE.ACCOUNT_LOAN;

  const getListAccountFromType = React.useCallback((list?: ACCOUNT[]) => {
    const listPayment: ACCOUNT[] = [];
    const listTerm: ACCOUNT[] = [];
    const listLoan: ACCOUNT[] = [];
    if (list && list?.length > 0)
      list.filter((item) => {
        if (accountPayment(item)) listPayment.push(item);
        if (accountSaving(item)) listTerm.push(item);
        if (accountLoan(item)) listLoan.push(item);
      });
    return { listPayment, listTerm, listLoan };
  }, []);

  const onPressDetail = (account: ACCOUNT) => {
    if (account.ACCOUNTNO && account.ACCOUNTNO?.length > 0) {
      navigate(ScreenNameType.DETAIL_ACCOUNT_ROLL, { account: account });
    }
  };

  React.useEffect(() => {
    if (listAccountStore) {
      const { listPayment, listTerm, listLoan } = getListAccountFromType(listAccountStore.ACCOUNT);
      const mapPayments = mapAccountPayments(listPayment);
      setData({ Payments: mapPayments, Terms: listTerm, Loans: listLoan });
    }
  }, [getListAccountFromType, listAccountStore]);

  React.useEffect(() => {
    dispatchStore(fetchListAccountRequest());
  }, [dispatchStore]);

  const ButtonRow = (
    <Block row middle pv={spacing.huge}>
      <Button onPress={goManager} mode="contained" style={styles.buttonForm}>
        {t("COMMON_QUAY_LAI")}
      </Button>
      <QueueSpacing size="large" />
      <Button onPress={goHome} mode="contained">
        {t("FUNC_TRANG_CHU")}
      </Button>
    </Block>
  );

  return (
    <Block flex={1}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={t("ACC_DANH_SACH_TAI_KHOAN")} subtitles={subtitlesArrays} />
        {isMobile ? (
          <AccountRollItem data={data} onPressItem={onPressDetail} />
        ) : (
          <AccountRollTable data={data} onPressItem={onPressDetail} />
        )}
        {ButtonRow}
      </ScrollView>
    </Block>
  );
};

export default AccountRoll;
